import React, { Fragment } from "react"

import Sub from "~layout/sub"
import GridContent from "./GridContent"

import aside from "~content/blog/aside"

const crumbs = [
  { text: "Blog"},
]

const BlogPage = () => {
  const content = (
    <Fragment>
      <h1>Blog</h1>
      <GridContent />
    </Fragment>
  )

  return (
    <Sub
      title="Blog Entries"
      crumbs={crumbs}
      content={content}
      aside={aside}
      sectionId = "blog_" 
    />
  )
}

export default BlogPage
